<template>
	<div class="flex items-center justify-between w-full ms-pagination">
		<div class="left-pagination">
			Tổng số:
			<b>{{ pageTotal }}</b> bản ghi
		</div>
		<div class="flex postion-pagination align-center">
			<!-- <div class="record-in-page">
      <ms-combo-box
        :store="recordInPageStore"
        v-model="modeRecordInPage"
        mode='dropdownlist'
        displayField="recordInPageDisplay"
        valueField="recordInPageValue"
        autoLoad
        queryMode="local"
        @selected='selectRecordInPage'
      ></ms-combo-box>
      </div>-->
			<div style="display: flex; align-items: center">
				<!--  <div
      @click="firstPage"
      :class="{'disableText': disablePrevPage}"
      class="mr-4 cursor-pointer unselect"
        >&lt; Đầu</div>-->
				<div
					@click="previousPage"
					:class="{ disableText: disablePrevPage }"
					class="mr-4 cursor-pointer unselect"
				>
					Trước
				</div>
				<div
					class="pl-2 pr-2 cursor-pointer"
					:class="{ pageSelected: pageIndex == 1 }"
					@click="loadPageIndex(1)"
				>
					1
				</div>
				<div
					class="pl-2 pr-2 cursor-pointer"
					v-if="checkFirstDotted"
					@click="changeView('previous')"
				>
					...
				</div>
				<div
					class="pl-2 pr-2 cursor-pointer"
					v-for="n in middlePage"
					:key="n"
					:class="{ pageSelected: pageIndex == n }"
					@click="loadPageIndex(n)"
				>
					{{ n }}
				</div>
				<div
					class="pl-2 pr-2 cursor-pointer"
					v-if="checkSecondDotted"
					@click="changeView('next')"
				>
					...
				</div>
				<div
					class="pl-2 pr-2 cursor-pointer"
					v-if="totalPages > 3"
					:class="{ pageSelected: pageIndex == totalPages }"
					@click="loadPageIndex(totalPages)"
				>
					{{ totalPages }}
				</div>
				<div
					@click="nextPage"
					:class="{ disableText: disableNextPage }"
					class="ml-4 cursor-pointer unselect"
				>
					Sau
				</div>

				<!-- <div class="unselect">
      <span>{{(pageIndex - 1)*pageSizeCustom + 1}}</span>
      <span> -</span>
      {{toNumberRecord}}
      <span></span>
      <span>của</span>
      <span> {{pageTotal}}</span>
    </div>
    <div @click="nextPage" :class="{'disableText': disableNextPage}" class="ml-4 cursor-pointer unselect">Sau</div>
    <div
      @click="lastPage"
      :class="{'disableText': disableNextPage}"
      class="ml-4 cursor-pointer unselect"
        >Cuối &gt;</div>-->
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'msPagination',
	props: {
		pageSize: {
			default: 0,
			type: [Number, String],
		},
		dataRender: {
			default: 0,
			type: [Number, String],
		},
		/**
		 * Tổng số bản ghi của dữ liệu
		 */
		pageTotal: {
			default: 0,
			type: [Number, String],
		},
		pageIndex: {
			default: 1,
			type: Number,
		},
	},
	computed: {
		//Tạo middle page hiển thị
		//Created by LTDAT (01/04/2020)
		middlePage() {
			let middle = [];
			if (this.totalPages == 2) {
				middle = [2];
			} else if (this.viewPage > 2 && this.viewPage <= this.totalPages - 3) {
				middle = [this.viewPage, this.viewPage + 1, this.viewPage + 2];
			} else if (this.viewPage > this.totalPages - 3 && this.viewPage > 3) {
				middle = [this.totalPages - 2, this.totalPages - 1];
			} else if (this.viewPage == 3 && this.totalPages == 5) {
				middle = [this.totalPages - 2, this.totalPages - 1];
			} else if (this.totalPages >= 3) {
				middle = [2, 3];
			}
			return middle;
		},
		//Kiểm tra hiện thị ... đầu tiên
		//Created by LTDAT (01/04/2020)

		checkFirstDotted() {
			let me = this,
				listFirst = [1, 2];
			return (
				this.totalPages > 4 &&
				listFirst.indexOf(this.viewPage) < 0 &&
				this.viewPage > 2
			);
		},
		//Kiểm tra hiện thị dấu ... thứ 2
		//Created by LTDAT (01/04/2020)

		checkSecondDotted() {
			return this.totalPages > 4 && this.viewPage <= this.totalPages - 3;
		},
		/**
		 * index của bản ghi cuối cùng trong trang trên tập dữ liệu trong DB
		 */
		toNumberRecord() {
			return (this.pageIndex - 1) * this.pageSize + this.dataRender;
		},

		/**
		 * Tổng số trang theo pageSize hiện tại của grid
		 */
		totalPages() {
			return Math.ceil(this.pageTotal / this.pageSize);
		},

		disableNextPage() {
			if (this.pageIndex >= this.totalPages && !this.useServerSide) {
				return true;
			}
			return false;
		},
		disablePrevPage() {
			if (this.pageIndex <= 1) {
				return true;
			}
			return false;
		},
	},
	data() {
		let me = this,
			grd = me.$parent,
			store = grd.store;
		return {
			viewPage: this.pageIndex,
			modeRecordInPage: 20,
			currentPage: this.pageIndex,
			//   recordInPageStore: new MSStore({
			// 			data: [
			// 				{
			// 					recordInPageValue: 10,
			// 					recordInPageDisplay: '10 bản ghi trên 1 trang'
			//       },
			//       {
			// 					recordInPageValue: 20,
			// 					recordInPageDisplay: '20 bản ghi trên 1 trang'
			//       },
			//       {
			// 					recordInPageValue: 30,
			// 					recordInPageDisplay: '30 bản ghi trên 1 trang'
			//       },
			//       {
			// 					recordInPageValue: 50,
			// 					recordInPageDisplay: '50 bản ghi trên 1 trang'
			//       },
			//       {
			// 					recordInPageValue: 100,
			// 					recordInPageDisplay: '100 bản ghi trên 1 trang'
			//       },
			// 			]
			//   }),
		};
	},
	mounted() {},
	methods: {
		//Chuyển view để nhìn số trang khác không thay đổi pageIndex phục vụ việc chọn khi ấn ...
		changeView(action) {
			if (action == 'next') {
				this.viewPage = this.middlePage[this.middlePage.length - 1] + 1;
			} else if (action == 'previous') {
				this.viewPage -= 3;
			}
		},
		//Load lại page theo số trang.
		loadPageIndex(index) {
			let me = this,
				grd = me.$parent,
				store = grd.store;
			if (grd.queryMode == 'local') {
				this.currentPage = index;
				grd.currentPage = index;
				grd.initData();
				// grd.loadData();
			} else {
				grd.doQuery({ pageIndex: index });
			}
			me.viewPage = index;
		},
		nextPage() {
			let me = this,
				grd = me.$parent,
				store = grd.store;
			//   let total = this.searchx ? this.getTotalPagesSearch : this.getTotalPages;
			if (me.pageIndex >= me.totalPages && !me.$parent.useServerSide) {
				return;
			}
			me.loadPageIndex(this.currentPage + 1);
			me.$emit('next', true);
		},

		firstPage() {
			let me = this,
				grd = me.$parent,
				store = grd.store;

			if (grd.queryMode == 'local') {
				this.currentPage = 1;
				grd.loadData();
			} else {
				grd.doQuery({ pageIndex: 1 });
			}

			// this.$parent.store.loadPage(1);
		},

		lastPage() {
			let me = this,
				grd = me.$parent,
				store = grd.store;
			if (grd.queryMode == 'local') {
				this.currentPage = me.totalPages;
				grd.loadData();
			} else {
				grd.doQuery({ pageIndex: me.totalPages });
			}

			// this.$parent.store.loadPage(this.pageIndex);
		},

		previousPage() {
			let me = this,
				grd = me.$parent,
				store = grd.store;

			if (me.pageIndex <= 1) {
				return;
			}
			me.loadPageIndex(this.currentPage - 1);
		},
		/**
		 * Thực hiện chọn số bản ghi trên một trang
		 * @author vvkiet 09.11.2019
		 */
		// selectRecordInPage(item){
		//   let me = this,
		//       grd = me.$parent,
		//       store = grd.store;
		// 		// if (me.pageIndex >= me.totalPages && !me.$parent.useServerSide) {
		// 		// 	return;
		//   // }
		//   me.$ms.session.set('RecordInPage', item.recordInPageValue);

		//   if(grd.queryMode == 'local')
		// 	{
		// 		this.currentPage = 1;
		// 		store.pageSize = item.recordInPageValue;
		// 		grd.loadData();
		// 	}
		// 	else
		// 	{
		// 		grd.$el.scrollIntoView();
		//   		  grd.doQuery({pageIndex: 1, pageSize: item.recordInPageValue});
		// 	}

		// }
	},
	watch: {
		pageSize(newValue, oldValue) {
			this.modeRecordInPage = newValue;
		},
	},
};
</script>
<style scoped lang='scss'>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
</style>

